import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { AlertBannerSuccess, IconHeart } from 'mage-deps/@klarna/bubble-ui'
import { translator } from 'mage-i18n'
import FreeTextFeedbackForm from './FreeTextFeedbackForm'
import { useSelector } from 'react-redux'

FreeTextFeedback.propTypes = {
  articleId: PropTypes.string.isRequired
}

export default function FreeTextFeedback({ articleId }) {
  const t = useSelector(translator)
  const [submited, setSubmited] = useState(false)

  if (submited) {
    return (
      <AlertBannerSuccess
        iconType={IconHeart}
        content={t(
          'hqm.freeTextFeedback.feedbackMessage',
          {},
          'Thank you for your feedback, this helps us a lot to provide you with more relevant articles in the future.'
        )}
      />
    )
  } else {
    const onSubmit = () => setSubmited(true)

    return <FreeTextFeedbackForm articleId={articleId} onSubmit={onSubmit} />
  }
}
